import { useMantineColorScheme, Switch } from "@mantine/core"
import { IconMoonStars, IconSun } from "@tabler/icons-react"

export const ColorToggle = React.forwardRef(ColorToggleComponent)

function ColorToggleComponent() {
  const { colorScheme, toggleColorScheme } = useMantineColorScheme()

  return (
    <Switch
      p="sm"
      value={colorScheme}
      onClick={() => toggleColorScheme()}
      onLabel={<IconSun />}
      offLabel={<IconMoonStars />}
      label={colorScheme.charAt(0).toUpperCase() + colorScheme.slice(1)}
    />
  )
}
